/* AIRE – Black Friday tiered discount UI + real-order notifications */
(() => {
  if (window.__aireBfLoaded) return;
  window.__aireBfLoaded = true;

  const CFG = window.AIRE_BF;
  if (!CFG) return;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const T = CFG.text || {};
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const money = (cents) => {
    let s = (Math.max(0, cents) / 100).toFixed(2).replace('.', ',');
    if (s.endsWith(',00')) s = s.slice(0, -3);
    return '€' + s;
  };
  const pctTxt = (p) => '−' + p + '%';
  const fill = (tpl, map) => esc(tpl).replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));
  const B = (s) => '<strong>' + s + '</strong>';

  /* ---------- Campaign window ---------- */
  const parseDate = (s) => {
    if (!s) return null;
    const d = new Date(String(s).trim().replace(' ', 'T') + (/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? '' : '+02:00'));
    return isNaN(d) ? null : d;
  };
  const campaignActive = () => {
    if (!CFG.enabled) return false;
    if (CFG.forceShow || CFG.designMode) return true;
    const now = new Date();
    const a = parseDate(CFG.start);
    const b = parseDate(CFG.end);
    if (a && now < a) return false;
    if (b && now > b) return false;
    return true;
  };
  const BF_ON = campaignActive();

  const tiers = (CFG.tiers || [])
    .map((t) => ({ min: Number(t.min) || 0, pct: Number(t.pct) || 0 }))
    .filter((t) => t.min > 0 && t.pct > 0)
    .sort((a, b) => a.min - b.min);

  /* ---------- Cart store ---------- */
  const store = {
    cart: CFG.cart || { sub: 0, total: 0, count: 0 },
    subs: new Set(),
  };
  const notify = () => store.subs.forEach((f) => { try { f(); } catch (e) { /* noop */ } });
  const refreshCart = () =>
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((r) => r.json())
      .then((c) => {
        store.cart = { sub: c.items_subtotal_price, total: c.total_price, count: c.item_count };
        notify();
      })
      .catch(() => {});
  ['cart:update', 'discount:update'].forEach((ev) =>
    document.addEventListener(ev, () => setTimeout(refreshCart, 60))
  );

  /* ---------- Tier maths ---------- */
  function compute(sub) {
    const n = tiers.length;
    let reached = -1;
    tiers.forEach((t, i) => { if (sub >= Math.round(t.min * 100)) reached = i; });
    const next = tiers[reached + 1];
    const seg = 100 / n;
    let w = 100;
    if (next) {
      const lo = reached < 0 ? 0 : Math.round(tiers[reached].min * 100);
      const hi = Math.round(next.min * 100);
      w = seg * (reached + 1) + seg * Math.max(0, Math.min(1, (sub - lo) / (hi - lo)));
    }
    let msg;
    if (reached < 0) {
      msg = fill(T.msgStart, { amount: B(money(Math.round(next.min * 100) - sub)), pct: B(pctTxt(next.pct)) });
    } else if (next) {
      msg = fill(T.msgNext, {
        current: esc(pctTxt(tiers[reached].pct)),
        amount: B(money(Math.round(next.min * 100) - sub)),
        pct: B(pctTxt(next.pct)),
      });
    } else {
      msg = fill(T.msgMax, { pct: B(pctTxt(tiers[reached].pct)) });
    }
    return { reached, next, w, msg, n, seg };
  }

  const tickMarks = (n) => {
    let h = '';
    for (let i = 1; i < n; i++) h += `<span class="tick" style="left:calc(${(100 / n) * i}% - 1px)"></span>`;
    return h;
  };

  const SHADOW_CSS = `
    :host{display:block;font:inherit;color:inherit}
    *{box-sizing:border-box}
    .box{background:var(--aire-dark);color:var(--aire-on-dark);border-radius:16px;padding:18px 16px 16px;display:flex;flex-direction:column;gap:14px}
    .box.compact{border-radius:14px;padding:12px 14px;gap:8px}
    .label{font-size:11px;font-weight:600;letter-spacing:.12em;color:var(--aire-accent);text-transform:uppercase}
    .h{font-family:var(--font-heading--family,inherit);font-size:20px;font-weight:600;line-height:1.2;margin:4px 0 0}
    .bar{position:relative;height:6px;border-radius:6px;background:var(--aire-line);overflow:hidden}
    .fill{position:absolute;top:0;bottom:0;left:0;background:var(--aire-accent);border-radius:6px;transition:width .5s ease}
    .tick{position:absolute;top:0;bottom:0;width:2px;background:var(--aire-dark)}
    .tiers{display:grid;gap:8px}
    .tier{position:relative;border-radius:12px;padding:12px 6px;text-align:center;border:1.5px solid var(--aire-line);background:var(--aire-dark-2);color:var(--aire-muted);display:flex;flex-direction:column;gap:2px}
    .tier.next{border-color:var(--aire-light);color:var(--aire-on-dark)}
    .tier.done{background:var(--aire-accent);border-color:var(--aire-accent);color:var(--aire-accent-text)}
    .tier small{font-size:12px}
    .tier b{font-family:var(--font-heading--family,inherit);font-size:24px;font-weight:700;line-height:1.1}
    .check{position:absolute;top:-8px;right:-6px;width:20px;height:20px;border-radius:10px;background:var(--aire-on-dark);display:flex;align-items:center;justify-content:center}
    .msg{font-size:14px;line-height:1.45;margin:0}
    .msg strong{color:var(--aire-accent);font-weight:600}
    .foot{display:flex;justify-content:space-between;gap:8px;flex-wrap:wrap;border-top:1px solid var(--aire-line);padding-top:12px;font-size:12px;color:var(--aire-muted)}
    .foot strong{color:var(--aire-on-dark)}
    .labels{display:grid;font-size:12px;text-align:right}
    .labels span{color:var(--aire-muted)}
    .labels span.on{color:var(--aire-accent);font-weight:600}
    .ship{display:flex;align-items:center;gap:8px;border-top:1px solid var(--aire-line);padding-top:10px;font-size:12px;color:var(--aire-muted)}
    .ship.ok{color:var(--aire-success)}
    .ship.ok strong,.ship.gift strong{color:var(--aire-accent)}
    .ship + .ship{border-top:0;padding-top:2px}
    .ship svg{flex-shrink:0}
    .ship.inline{border-top:0;padding-top:0;font-size:13px}
    .box.compact .msg{font-size:13px;line-height:1.35}
    .box.perks{padding:8px 12px;gap:4px;border-radius:10px}
    .box.perks .ship{font-size:12px;gap:6px;border-top:0;padding-top:0}
    .box.perks .ship svg{width:14px;height:14px}
    .check svg{stroke:var(--aire-dark)}
    @media (prefers-reduced-motion: reduce){.fill{transition:none}}
  `;
  const CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#170b02" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
  const TRUCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg>';

  const GIFT = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="9" width="18" height="12" rx="1"/><path d="M3 13h18M12 9v12"/><path d="M12 9c-1.5-3-5-3.5-5-1.2C7 9 9.5 9 12 9zM12 9c1.5-3 5-3.5 5-1.2C17 9 14.5 9 12 9z"/></svg>';
  const giftOn = () => CFG.gift && CFG.gift.enabled && Number(CFG.gift.min) > 0;
  const giftReached = (total) => giftOn() && total >= Math.round(CFG.gift.min * 100);
  const giftLine = (total, extra) => {
    if (!giftOn()) return '';
    const x = extra ? ' ' + extra : '';
    const left = Math.round(CFG.gift.min * 100) - total;
    return left > 0
      ? `<div class="ship gift${x}">${GIFT}<span>${fill(T.giftMsg, { amount: B(money(left)) })}</span></div>`
      : `<div class="ship ok${x}">${GIFT}<span>${esc(T.giftDone)}</span></div>`;
  };

  const shipLine = (total) => {
    if (!CFG.freeShip) return '';
    const left = Math.round(CFG.freeShip * 100) - total;
    return left > 0
      ? `<div class="ship">${TRUCK}<span>${fill(T.shipMsg, { amount: B(money(left)) })}</span></div>`
      : `<div class="ship ok">${TRUCK}<span>${esc(T.shipDone)}</span></div>`;
  };

  /* ---------- <aire-bf-tiers> : product page ---------- */
  class AireBfTiers extends HTMLElement {
    connectedCallback() {
      if (!BF_ON || !tiers.length || !(CFG.show && CFG.show.product)) { this.hidden = true; return; }
      if (!this.shadowRoot) this.attachShadow({ mode: 'open' });
      this._f = () => this.render();
      store.subs.add(this._f);
      this.render();
    }
    disconnectedCallback() { if (this._f) store.subs.delete(this._f); }
    render() {
      const sub = store.cart.sub || 0;
      const s = compute(sub);
      const cards = tiers
        .map((t, i) => {
          const cls = i <= s.reached ? 'done' : i === s.reached + 1 ? 'next' : '';
          return `<div class="tier ${cls}"><small>${esc(T.tierFrom)} ${money(Math.round(t.min * 100))}</small><b>${pctTxt(t.pct)}</b>${
            i <= s.reached ? `<span class="check">${CHECK}</span>` : ''
          }</div>`;
        })
        .join('');
      this.shadowRoot.innerHTML = `<style>${SHADOW_CSS}</style>
        <div class="box" role="region" aria-label="${esc(T.productLabel)}">
          <div><div class="label">${esc(T.productLabel)}</div><p class="h">${esc(T.productHeading)}</p></div>
          <div class="bar" aria-hidden="true"><div class="fill" style="width:${s.w.toFixed(2)}%"></div>${tickMarks(s.n)}</div>
          <div class="tiers" style="grid-template-columns:repeat(${s.n},minmax(0,1fr))">${cards}</div>
          <p class="msg" aria-live="polite">${s.msg}</p>
          ${giftLine(store.cart.total || 0, 'inline')}
          <div class="foot"><span>${esc(T.inCart)} <strong>${money(sub)}</strong></span><span>${esc(T.productNote)}</span></div>
        </div>`;
    }
  }

  /* ---------- <aire-bf-cart> : cart drawer + cart page ---------- */
  class AireBfCart extends HTMLElement {
    static get observedAttributes() { return ['data-subtotal', 'data-total']; }
    connectedCallback() {
      if (!BF_ON || !tiers.length || !(CFG.show && CFG.show.cart)) { this.hidden = true; return; }
      if (!this.shadowRoot) this.attachShadow({ mode: 'open' });
      this._f = () => this.render();
      store.subs.add(this._f);
      this.render();
    }
    disconnectedCallback() { if (this._f) store.subs.delete(this._f); }
    attributeChangedCallback() { if (this.shadowRoot) this.render(); }
    render() {
      const a = parseInt(this.dataset.subtotal, 10);
      const b = parseInt(this.dataset.total, 10);
      const sub = isNaN(a) ? store.cart.sub : a;
      const total = isNaN(b) ? store.cart.total : b;
      const wrap = this.closest('.aire-bf-cart-wrap');
      const empty = isNaN(a) && !store.cart.count;
      if (wrap) wrap.hidden = empty;
      if (empty) { this.shadowRoot.innerHTML = ''; return; }
      const part = this.dataset.part || 'all';
      if (part === 'perks') {
        const perks = shipLine(total) + giftLine(total);
        if (wrap) wrap.hidden = !perks;
        this.shadowRoot.innerHTML = perks ? `<style>${SHADOW_CSS}</style><div class="box perks" aria-live="polite">${perks}</div>` : '';
        return;
      }
      const s = compute(sub);
      const labels = tiers
        .map((t, i) => `<span class="${i <= s.reached ? 'on' : ''}">${pctTxt(t.pct)}</span>`)
        .join('');
      this.shadowRoot.innerHTML = `<style>${SHADOW_CSS}</style>
        <div class="box compact">
          <p class="msg" aria-live="polite">${s.msg}</p>
          <div class="bar" aria-hidden="true"><div class="fill" style="width:${s.w.toFixed(2)}%"></div>${tickMarks(s.n)}</div>
          <div class="labels" style="grid-template-columns:repeat(${s.n},minmax(0,1fr))">${labels}</div>
          ${part === 'all' ? shipLine(total) + giftLine(total) : ''}
        </div>`;
    }
  }

  if (!customElements.get('aire-bf-tiers')) customElements.define('aire-bf-tiers', AireBfTiers);
  if (!customElements.get('aire-bf-cart')) customElements.define('aire-bf-cart', AireBfCart);

  /* ---------- Banner + badges ---------- */
  function initBanner() {
    const banner = document.querySelector('[data-aire-bf-banner]');
    if (!banner) return;
    if (!BF_ON) { banner.remove(); return; }
    banner.hidden = false;
    if (!CFG.designMode) {
      const main = document.getElementById('MainContent') || document.querySelector('main');
      if (main) main.prepend(banner);
    }
  }
  function initBadges() {
    if (!BF_ON || !(CFG.show && CFG.show.badges)) return;
    document.documentElement.classList.add('aire-bf-badges-on');
  }

  /* ---------- Placement (no theme file edits needed; survives re-renders) ---------- */
  function placeAll() {
    if (!BF_ON || !tiers.length) return;
    if (CFG.show && CFG.show.product && CFG.pageType === 'product') {
      const btn = document.querySelector('#MainContent .product-form-buttons .add-to-cart-button, main .product-form-buttons .add-to-cart-button');
      if (btn) {
        const row = btn.closest('.product-form-buttons');
        let slot = btn;
        while (slot.parentElement && slot.parentElement !== row) slot = slot.parentElement;
        const el = document.querySelector('#MainContent aire-bf-tiers, main aire-bf-tiers') || document.createElement('aire-bf-tiers');
        if (slot.nextElementSibling !== el) slot.after(el);
      }
    }
    if (CFG.show && CFG.show.cart) {
      const make = (cls, part) => {
        const wrap = document.createElement('div');
        wrap.className = cls;
        const el = document.createElement('aire-bf-cart');
        el.dataset.part = part;
        wrap.appendChild(el);
        return wrap;
      };
      document.querySelectorAll('.cart-drawer__content').forEach((content) => {
        if (content.querySelector('aire-bf-cart[data-part="tiers"]')) return;
        const items = content.querySelector('.cart-drawer__items');
        if (!items) return;
        items.before(make('aire-bf-cart-wrap', 'tiers'));
      });
      if (CFG.pageType === 'cart') {
        const inner = document.querySelector('.cart__summary-inner');
        if (inner && !inner.querySelector('aire-bf-cart[data-part="tiers"]')) {
          inner.prepend(make('aire-bf-cart-wrap aire-bf-cart-wrap--page', 'tiers'));
        }
      }
      document.querySelectorAll('.cart__ctas').forEach((ctas) => {
        const prev = ctas.previousElementSibling;
        if (prev && prev.classList.contains('aire-bf-cart-wrap--perks')) return;
        ctas.before(make('aire-bf-cart-wrap aire-bf-cart-wrap--perks', 'perks'));
      });
    }
    if (CFG.show && CFG.show.badges) {
      document.querySelectorAll('.product-badges').forEach((b) => {
        if (b.querySelector('.aire-bf-badge')) return;
        const d = document.createElement('div');
        d.className = 'product-badges__badge product-badges__badge--rectangle aire-bf-badge';
        b.appendChild(d);
      });
    }
  }
  function initPlacement() {
    placeAll();
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; placeAll(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Sticky mini bar ---------- */
  function initSticky() {
    if (!BF_ON || !tiers.length || !(CFG.show && CFG.show.sticky)) return;
    if (CFG.pageType === 'cart') return;
    const a = document.createElement('a');
    a.className = 'aire-bf-sticky';
    a.href = ROOT + 'cart';
    a.hidden = true;
    document.body.appendChild(a);
    a.addEventListener('click', (e) => {
      if (!store.cart.count) { e.preventDefault(); location.href = ROOT + 'collections/all'; return; }
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) { e.preventDefault(); trigger.click(); }
    });
    const render = () => {
      const c = store.cart;
      const s = compute(c.sub);
      const msg = s.next
        ? fill(T.stickyMsg, { amount: B(money(Math.round(s.next.min * 100) - c.sub)), pct: B(pctTxt(s.next.pct)) })
        : s.msg;
      a.innerHTML = `<span class="aire-bf-sticky__main"><span class="aire-bf-sticky__msg">${msg}</span><span class="aire-bf-sticky__bar"><span style="width:${s.w.toFixed(2)}%"></span></span>${giftReached(c.total) ? `<span class="aire-bf-sticky__gift">${GIFT}${esc(T.giftSticky)}</span>` : ''}</span><span class="aire-bf-sticky__btn">${esc(T.stickyBtn)}</span>`;
      a.hidden = false;
      document.body.classList.add('aire-has-sticky');
    };
    store.subs.add(render);
    render();
  }

  /* ---------- Real-order notifications ---------- */
  function initSocialProof() {
    const SP = CFG.sp || {};
    if (!SP.enabled || CFG.pageType === 'cart') return;
    const ss = {
      get(k, d) { try { const v = sessionStorage.getItem('aireSp:' + k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
      set(k, v) { try { sessionStorage.setItem('aireSp:' + k, JSON.stringify(v)); } catch (e) { /* noop */ } },
    };
    let data = null;
    const readJson = (el) => { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
    data = readJson(document.getElementById('aire-sp-data'));
    let prod = readJson(document.querySelector('script[data-aire-product-sales]'));

    const pollUrl = (CFG.pageType === 'product' ? location.pathname : ROOT) + '?sections=aire-social-proof';
    const poll = () =>
      fetch(pollUrl, { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((j) => {
          const tmp = document.createElement('div');
          tmp.innerHTML = j['aire-social-proof'] || '';
          const d = readJson(tmp.querySelector('script[type="application/json"]:not([data-aire-product-sales])'));
          if (d) data = d;
          const p = readJson(tmp.querySelector('script[data-aire-product-sales]'));
          if (p) prod = p;
          renderChip();
        })
        .catch(() => {});
    const pollMs = Math.max(30, Number(SP.poll) || 60) * 1000;
    setInterval(() => { if (!document.hidden) poll(); }, pollMs);

    const sofiaToday = () => {
      try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Sofia' }).format(new Date()); }
      catch (e) { return new Date().toISOString().slice(0, 10); }
    };
    const ago = (iso) => {
      const m = Math.floor((Date.now() - Date.parse(iso)) / 60000);
      if (isNaN(m)) return '';
      if (m < 1) return 'току-що';
      if (m < 60) return 'преди ' + m + ' мин';
      const h = Math.floor(m / 60);
      if (h < 24) return 'преди ' + h + ' ч';
      if (h < 48) return 'вчера';
      return 'преди ' + Math.floor(h / 24) + ' дни';
    };
    const currentHandle = (() => {
      const m = location.pathname.match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    })();

    const box = document.createElement('div');
    box.className = 'aire-sp';
    box.setAttribute('aria-live', 'polite');
    document.body.appendChild(box);

    const FLAME = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ce9975" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22c4 0 7-2.7 7-6.8 0-3.5-2.4-5.6-3.8-7.6-.4 1.8-1.3 3-2.6 3.6.2-3.4-1.1-6.4-3.6-8.2.1 3.1-1.8 5.2-3.3 7C4.6 11.3 5 12.8 5 15.2 5 19.3 8 22 12 22z"/></svg>';
    const VIAL = '<svg width="18" height="36" viewBox="0 0 120 240" fill="none" aria-hidden="true"><rect x="44" y="10" width="32" height="34" rx="6" fill="#170b02"/><rect x="26" y="56" width="68" height="170" rx="14" fill="#fff" stroke="#dbbaa4" stroke-width="6"/></svg>';
    const TICK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
    const FLAME_SM = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ce9975" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22c4 0 7-2.7 7-6.8 0-3.5-2.4-5.6-3.8-7.6-.4 1.8-1.3 3-2.6 3.6.2-3.4-1.1-6.4-3.6-8.2.1 3.1-1.8 5.2-3.3 7C4.6 11.3 5 12.8 5 15.2 5 19.3 8 22 12 22z"/></svg>';
    const CLOSE = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

    const counterInfo = () => {
      if (!data) return null;
      const min = Number(SP.minToday) || 5;
      const today = data.date === sofiaToday() ? Number(data.today) || 0 : 0;
      if (today >= min) return { title: fill(SP.countTitle, { count: esc(today) }), text: esc(SP.countText) };
      const week = Number(data.week) || 0;
      if (week >= min) return { title: fill(SP.weekTitle, { count: esc(week) }), text: esc(SP.weekText) };
      return null;
    };
    /* Live “orders today” chip next to the price (product page) */
    let chip = null;
    const productChip = () => {
      if (!prod) return null;
      const utcToday = new Date().toISOString().slice(0, 10);
      const today = (prod.date === utcToday ? Number(prod.today) || 0 : 0) + (prod.seedDate === sofiaToday() ? Number(prod.seedToday) || 0 : 0);
      const total = (Number(prod.total) || 0) + (Number(prod.seedTotal) || 0);
      if (today >= (Number(SP.prodMinToday) || 3)) return fill(SP.soldToday, { count: B(esc(today)) });
      if (total >= (Number(SP.prodMinTotal) || 10)) return fill(SP.soldTotal, { count: B(esc(total)) });
      return null;
    };
    const chipInfo = () => {
      const pc = productChip();
      if (pc) return pc;
      if (!data) return null;
      const min = Number(SP.minToday) || 5;
      const today = data.date === sofiaToday() ? Number(data.today) || 0 : 0;
      if (today >= min) return fill(SP.countTitle, { count: B(esc(today)) });
      const week = Number(data.week) || 0;
      if (week >= min) return fill(SP.weekTitle, { count: B(esc(week)) });
      return null;
    };
    function renderChip() {
      if (CFG.pageType !== 'product') return;
      const html = chipInfo();
      if (!html) { if (chip) chip.hidden = true; return; }
      if (!chip) { chip = document.createElement('div'); chip.className = 'aire-sp-chip'; }
      chip.innerHTML = FLAME_SM + '<span>' + html + '</span>';
      chip.hidden = false;
      placeChip();
    }
    function placeChip() {
      if (!chip || chip.hidden) return;
      const price = document.querySelector('#MainContent product-price, main product-price');
      if (!price) return;
      const amount = Array.from(price.children).find((c) => c !== chip);
      if (!amount) { if (chip.parentElement !== price) price.appendChild(chip); return; }
      if (amount.nextElementSibling !== chip) amount.after(chip);
    }
    if (CFG.pageType === 'product') {
      let q = false;
      new MutationObserver(() => {
        if (q) return;
        q = true;
        requestAnimationFrame(() => { q = false; placeChip(); });
      }).observe(document.body, { childList: true, subtree: true });
    }

    const keyOf = (o) => (o.at || '') + '|' + (o.handle || o.product || '');
    const pickOrder = () => {
      if (!data || !Array.isArray(data.orders)) return null;
      const shown = ss.get('shown', []);
      const maxAge = (Number(SP.maxAgeHours) || 48) * 3600000;
      const fresh = data.orders.filter(
        (o) => o && o.at && Date.now() - Date.parse(o.at) <= maxAge && !shown.includes(keyOf(o))
      );
      if (!fresh.length) return null;
      fresh.sort((a, b) => Date.parse(b.at) - Date.parse(a.at));
      const same = currentHandle ? fresh.find((o) => o.handle === currentHandle) : null;
      return same || fresh[0];
    };

    const orderHtml = (o) => {
      const same = currentHandle && o.handle === currentHandle;
      const city = String(o.city || '').trim();
      const title = city ? fill(SP.buyTitle, { city: esc(city.charAt(0).toUpperCase() + city.slice(1)) }) : esc(SP.buyTitleNoCity);
      const prod = esc(o.product || '') + (o.variant && o.variant !== 'Default Title' ? ' · ' + esc(o.variant) : '');
      const text = same
        ? esc(SP.buySame) + (o.variant && o.variant !== 'Default Title' ? ' · ' + esc(o.variant) : '')
        : fill(SP.buyOther, { product: prod });
      const thumb = o.image ? `<img src="${esc(o.image)}" alt="" width="48" height="48" loading="lazy">` : VIAL;
      const href = !same && o.handle ? ROOT + 'products/' + encodeURIComponent(o.handle) : null;
      const body = `<span class="aire-sp__title">${title}</span><span class="aire-sp__text">${text}</span><span class="aire-sp__meta">${TICK}${esc(SP.verified)} · ${esc(ago(o.at))}</span>`;
      return `<div class="aire-sp__toast" role="status"><span class="aire-sp__thumb">${thumb}</span>${
        href ? `<a class="aire-sp__body" href="${href}">${body}</a>` : `<span class="aire-sp__body">${body}</span>`
      }<button type="button" class="aire-sp__close" aria-label="${esc(SP.closeLabel)}">${CLOSE}</button></div>`;
    };
    const counterHtml = (c) =>
      `<div class="aire-sp__toast aire-sp__toast--dark" role="status"><span class="aire-sp__thumb">${FLAME}</span><span class="aire-sp__body"><span class="aire-sp__title">${c.title}</span><span class="aire-sp__text">${c.text}</span></span><button type="button" class="aire-sp__close" aria-label="${esc(SP.closeLabel)}">${CLOSE}</button></div>`;

    const showMs = Math.max(3, Number(SP.showSeconds) || 6) * 1000;
    const gapMs = Math.max(5, Number(SP.gapSeconds) || 20) * 1000;
    const maxPer = Math.max(1, Number(SP.maxPerVisit) || 5);
    let timer = null;

    const showNext = () => {
      if (ss.get('closed', false)) return;
      let count = ss.get('count', 0);
      if (count >= maxPer) return;
      let html = null;
      const counterDone = ss.get('counter', false);
      const c = !counterDone ? counterInfo() : null;
      if (c) { html = counterHtml(c); ss.set('counter', true); }
      else {
        const o = pickOrder();
        if (o) { html = orderHtml(o); const shown = ss.get('shown', []); shown.push(keyOf(o)); ss.set('shown', shown.slice(-50)); }
        else if (c) { html = counterHtml(c); ss.set('counter', true); }
      }
      if (!html) { timer = setTimeout(showNext, gapMs); return; }
      ss.set('count', count + 1);
      box.innerHTML = html;
      const el = box.firstElementChild;
      el.querySelector('.aire-sp__close').addEventListener('click', () => {
        ss.set('closed', true);
        clearTimeout(timer);
        el.classList.remove('is-in');
        setTimeout(() => (box.innerHTML = ''), 300);
      });
      requestAnimationFrame(() => el.classList.add('is-in'));
      timer = setTimeout(() => {
        el.classList.remove('is-in');
        setTimeout(() => { if (box.firstElementChild === el) box.innerHTML = ''; }, 350);
        timer = setTimeout(showNext, gapMs);
      }, showMs);
    };

    renderChip();
    if (CFG.designMode || ss.get('closed', false)) return;

    const dMin = Math.max(1, Number(SP.firstMin) || 5);
    const dMax = Math.max(dMin, Number(SP.firstMax) || 8);
    timer = setTimeout(showNext, (dMin + Math.random() * (dMax - dMin)) * 1000);
  }

  const start = () => { initBanner(); initBadges(); initPlacement(); initSticky(); initSocialProof(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
